import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { fetchData, updateData, postData } from '../../../apiService';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Tooltip } from '@material-ui/core';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import AsyncCreatableSelect from 'react-select/async-creatable';
import { useLocation } from 'react-router-dom';
import Select from "react-select"; // regular select

const PurchaseDetails = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const [selectedItems, setSelectedItems] = useState([]);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [formData, setFormData] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        // Authentication and token expiration handling
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // Other initializations, if any
    }, [isAuthenticated, companyId, branchId, userId, token, logout]);
    const [purchaseId, setpurchaseId] = useState("");

    useEffect(() => {
        fetchData('PurchaseApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Purchase);
                    setpurchaseId(response.response_data.Purchase.Id);
                    setSelectedItems(response.response_data.PurchaseDetails);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    //handle search [ITEM SEARCH]   
    const [searchQuery, setSearchQuery] = useState('');
    //search
    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };



    // ── shared styles ────────────────────────────────────────────────────────
    const inp  = { border: "1px solid rgba(0,0,0,0.12)", borderRadius: "7px", fontSize: "12px", height: "28px", width: "100%", padding: "0 8px", outline: "none", backgroundColor: "#f8fafa", boxSizing: "border-box" };
    const inpR = { ...inp, textAlign: "right" };
    const card = { backgroundColor: "#ffffff", borderRadius: "10px", boxShadow: "0 2px 10px rgba(0,0,0,0.07)", border: "1px solid rgba(0,0,0,0.06)", marginBottom: "10px", overflow: "hidden" };
    const cardHead = (color = "#2dd4bf") => ({ display: "flex", alignItems: "center", gap: "6px", padding: "6px 12px", borderBottom: "1px solid rgba(0,0,0,0.06)", backgroundColor: `${color}18`, fontSize: "10px", fontWeight: 700, color: "#1a2e2e", textTransform: "uppercase", letterSpacing: "0.5px" });
    const cardBody = { padding: "10px 12px" };
    const lbl = { fontSize: "9.5px", fontWeight: 700, color: "#5a7a7a", textTransform: "uppercase", letterSpacing: "0.5px", display: "block", marginBottom: "3px" };

    return (
        <div style={{ fontFamily: "Segoe UI, sans-serif", fontSize: "12px", width: "100%", padding: "6px 6px 6px", boxSizing: "border-box", backgroundColor: "#f0f4f4" }}>

            {/* ── Header card ── */}
            <div style={{ ...card, overflow: "visible" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", flexWrap: "wrap", gap: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <span style={{ fontSize: "15px", color: "#2dd4bf" }}>🛒</span>
                        <span style={{ fontWeight: 800, fontSize: "13px", color: "#1a2e2e", fontFamily: "Inter, sans-serif" }}>Purchase Details</span>
                    </div>

                    {/* Supplier (read-only) */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span style={{ fontSize: "11px", fontWeight: 600, color: "#5a7a7a", whiteSpace: "nowrap" }}>
                            Supplier
                            {formData.InvoiceTypeName && <span style={{ color: "#2dd4bf", marginLeft: "6px" }}>({formData.InvoiceTypeName})</span>}
                        </span>
                        <input type="text" value={formData.SupplierName || ""} readOnly
                            style={{ ...inp, width: "260px", backgroundColor: "#f8fafa", cursor: "default" }} />
                    </div>

                    {/* Back button */}
                    <Link to="/PurchaseIndex" onClick={() => localStorage.setItem("shouldReload", "true")}
                        style={{ height: "28px", padding: "0 14px", borderRadius: "7px", border: "1px solid rgba(0,0,0,0.12)", backgroundColor: "#fff", color: "#5a7a7a", fontWeight: 600, fontSize: "11px", cursor: "pointer", display: "flex", alignItems: "center", textDecoration: "none" }}>
                        ← Back
                    </Link>
                </div>
            </div>

            {/* ── Error ── */}
            {errorMessage && (
                <div style={{ marginBottom: "8px", padding: "6px 12px", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "7px", fontSize: "11px", color: "#ef4444" }}>
                    {errorMessage}
                </div>
            )}

            {/* ── Bill details card (read-only) ── */}
            <div style={card}>
                <div style={cardHead()}>📋 Bill Details</div>
                <div style={{ ...cardBody, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))", gap: "10px" }}>
                    <div><label style={lbl}>Bill Date</label><input type="date" value={formatDateForInput(formData.BillDate)} readOnly style={inp} /></div>
                    <div><label style={lbl}>Bill Number</label><input type="text" value={formData.BillNumber || ""} readOnly style={inp} /></div>
                    <div><label style={lbl}>Clearing Date</label><input type="date" value={formatDateForInput(formData.ClearingDate)} readOnly style={inp} /></div>
                    <div>
                        <label style={lbl}>Freight <span style={{ color: "#8b5cf6", marginLeft: 4 }}>({formData.FreightGSTRate}%)</span><span style={{ color: "#ef4444", marginLeft: 4 }}>{formData.FreightGSTAmount}</span></label>
                        <input type="number" value={formData.FreightAmount || 0} readOnly style={inpR} />
                    </div>
                    <div>
                        <label style={lbl}>Packing <span style={{ color: "#8b5cf6", marginLeft: 4 }}>({formData.PackingGSTRate}%)</span><span style={{ color: "#ef4444", marginLeft: 4 }}>{formData.PackingGSTAmount}</span></label>
                        <input type="number" value={formData.PackingAmount || 0} readOnly style={inpR} />
                    </div>
                    <div><label style={lbl}>TCS</label><input type="number" value={formData.TCSAmount || 0} readOnly style={inpR} /></div>
                    <div><label style={lbl}>Round Off</label><input type="number" value={formData.RoundOff || 0} readOnly style={inpR} /></div>
                    <div><label style={lbl}>Total</label><input type="number" value={formData.TotalAmount || 0} readOnly style={{ ...inpR, fontWeight: 700, color: "#0D47A1" }} /></div>
                    <div><label style={lbl}>Cash</label><input type="number" value={formData.PaidAmount || 0} readOnly style={{ ...inpR, fontWeight: 700, color: "#0D47A1" }} /></div>
                    <div>
                        <label style={lbl}>Balance</label>
                        <input type="text" value={formData.BalanceAmount || 0} readOnly
                            style={{ ...inpR, fontWeight: 700, color: parseFloat(formData.BalanceAmount) > 0 ? "#ef4444" : "#1a2e2e" }} />
                    </div>
                    <div style={{ gridColumn: "span 2" }}>
                        <label style={lbl}>Store Location</label>
                        <input type="text" value={formData.StoreLocationName || ""} readOnly
                            style={{ ...inp, backgroundColor: "#f8fafa", cursor: "default" }} />
                    </div>
                </div>
            </div>

            {/* ── Summary bar ── */}
            <div style={card}>
                <div style={{ ...cardBody, display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: "8px" }}>
                    {[["Amount", formData.Amount], ["Discount", formData.DiscountAmount], ["Taxable", formData.TaxableAmount], ["CGST", formData.CGSTAmount], ["SGST", formData.SGSTAmount], ["IGST", formData.IGSTAmount]].map(([label, val]) => (
                        <div key={label} style={{ fontSize: "11px", color: "#5a7a7a" }}>{label}: <strong style={{ color: "#B71C1C" }}>{val}</strong></div>
                    ))}
                </div>
            </div>

            {/* ── Items table card (read-only) ── */}
            <div style={card}>
                <div style={cardHead("#1F2A38")}>📦 Items ({filteredData.length})</div>
                <div style={{ maxHeight: "320px", overflowY: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                        <thead style={{ backgroundColor: "#1F2A38", color: "#fff", position: "sticky", top: 0 }}>
                            <tr>
                                {["#", "Item", "Qty", "Rate", "Amount", "Disc%", "Disc₹", "Taxable", "GST₹", "Total"].map((h, i) => (
                                    <th key={i} style={{ padding: "6px 4px", textAlign: i > 1 ? "right" : "left", fontSize: "10px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.4px", whiteSpace: "nowrap" }}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((item, index) => (
                                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#fff" : "#f8fafc", borderBottom: "1px solid #e5e7eb" }}>
                                    <td style={{ padding: "3px 6px", textAlign: "center" }}>{index + 1}</td>
                                    <td style={{ padding: "3px 4px", minWidth: "160px", fontWeight: 600 }}>{item.ItemName}</td>
                                    <td style={{ padding: "2px", width: "70px" }}><input type="number" value={item.Quantity} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                    <td style={{ padding: "2px", width: "100px" }}><input type="number" value={item.Rate || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                    <td style={{ padding: "2px", width: "100px" }}><input value={item.Amount || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                    <td style={{ padding: "2px", width: "80px" }}><input type="number" value={item.DiscountPercentage || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                    <td style={{ padding: "2px", width: "90px" }}><input value={item.DiscountAmount || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                    <td style={{ padding: "2px", width: "100px" }}><input value={item.TaxableAmount || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                    <td style={{ padding: "2px", width: "100px" }}>
                                        <input value={(parseFloat(item.CGSTAmount || 0) + parseFloat(item.SGSTAmount || 0) + parseFloat(item.IGSTAmount || 0)).toFixed(2)} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px", width: "65%" }} />
                                        <span style={{ marginLeft: "3px", color: "#8b5cf6", fontSize: "10px" }}>{item.GSTRate ? parseFloat(item.GSTRate) : 0}%</span>
                                    </td>
                                    <td style={{ padding: "2px", width: "100px" }}><input value={item.TotalAmount || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px", fontWeight: 700, color: "#b45309" }} /></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ── Remarks card ── */}
            <div style={card}>
                <div style={cardHead("#f59e0b")}>📝 Remarks</div>
                <div style={cardBody}>
                    <textarea value={formData.Remarks || ""} readOnly rows={2}
                        style={{ border: "1px solid rgba(0,0,0,0.12)", borderRadius: "7px", fontSize: "12px", width: "100%", padding: "6px 8px", resize: "vertical", outline: "none", backgroundColor: "#f8fafa", boxSizing: "border-box" }} />
                </div>
            </div>

        </div>
    );
}
export default PurchaseDetails;

